import { fetchGraphQL } from 'core/services/graphQLservice'

// getMoveAndReviewDetailsByCustomer(customerID:"${CID}")
export async function callNowSMSService(customerID: string, customerName:string, estimatorPh:string, customerPh:string) {
//debugger;
    var params = `query{
        sendTextMessageToEstimator(customerID:"${customerID}", customerName:"${customerName}",estimatorPh:"${estimatorPh}", customerPh:"${customerPh}")
        {
            responseCode
      }
    }`;

    var response = await fetchGraphQL('POST', params);
    return response;
}